import { render, staticRenderFns } from "./SettleRules.vue?vue&type=template&id=7d583745&"
import script from "./SettleRules.vue?vue&type=script&lang=js&"
export * from "./SettleRules.vue?vue&type=script&lang=js&"
import style0 from "./SettleRules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports